import { useEventCallback } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { Section } from '../../components/Section';
import { selectBuilderHouses, selectBuilderInfo } from '../../selectors/builder';
import { IHouseView } from '../../types/builder';
import { ProjectModalContainer } from '../ProjectModalContainer';
import { HousesListContainer, HousesSliderContainer } from './containers';
import { trackClickHouseCard, trackClickPhoneButton } from './tracking';

export const HousesContainer = () => {
  const [selectedHouse, setSelectedHouse] = React.useState<IHouseView | null>(null);
  const deviceType = useDeviceType();
  const builderInfo = useSelector(selectBuilderInfo);
  const houses = useSelector(selectBuilderHouses);

  const handleHouseCardClick = useEventCallback((house: IHouseView) => {
    trackClickHouseCard(builderInfo.id, `${builderInfo.name} | ${house.name}`);
    setSelectedHouse(house);
  });

  const handlePhoneButtonClick = useEventCallback(() => {
    trackClickPhoneButton(builderInfo.id);
  });

  const handleCloseModal = useEventCallback(() => {
    setSelectedHouse(null);
  });

  if (!houses.length) {
    return null;
  }

  const Houses = deviceType === 'desktop' ? HousesListContainer : HousesSliderContainer;

  return (
    <div data-name="HousesSection">
      <Section title="Построенные дома" />
      <Houses houses={houses} onHouseClick={handleHouseCardClick} />
      {selectedHouse && (
        <ProjectModalContainer
          {...selectedHouse}
          onClose={handleCloseModal}
          onPhoneButtonClick={handlePhoneButtonClick}
        />
      )}
    </div>
  );
};
